<template>
  <div :class="['chat-view-wrapper', { 'active': active }]">
    <vue-resizable :class="['chat-view z-depth-5', { 'active': active }]" :active="['r']">
      <mdb-tooltip
        trigger="hover"
        :options="{ placement: 'right' }"
        material
      >
        <span v-if="!device.isMobile" slot="tip">チャット{{ active ? '非表示' : '表示'}}</span>
        <mdb-btn
          slot="reference"
          tag="a"
          color="success"
          class="btn-toggle-chat-view"
          @click.native="() => $emit('onclickChatViewButton')"
          floating>
          <div v-if="newArrival" class="new-badge-wrapper">
            <span class="new-badge animated flash slower infinite"/>
          </div>
          <mdb-icon :icon="active ? 'times' : 'comments'"/>
        </mdb-btn>
      </mdb-tooltip>
      <mdb-container>
        <mdb-row>
          <mdb-col col="12" class="chat-messages-container d-flex flex-column align-items-center justify-content-end">
            <div class="w-100 chat-messages-list" ref="chatMessagesList">
              <div :class="['w-75 mb-4 chat-message', { 'myself': message.myself }]" v-for="message in chatMessages" :key="message.id">
                <mdb-card class="animated zoomIn">
                  <mdb-card-body class="chat-message-card-body">
                    <div class="d-flex flex-column flex-md-row align-items-end justify-content-between">
                      <div class="card-text font-weight-bolder display-name">{{ message.displayName }}</div>
                      <div class="card-text message-date">{{ message.date }}</div>
                    </div>
                    <hr class="w-100 my-2"/>
                    <span class="card-text chat-text" v-html="sanitizeText(message.text)"></span>
                  </mdb-card-body>
                </mdb-card>
              </div>
            </div>
            <div class="w-100 pb-2 chat-message-form">
              <div class="form-group">
                <textarea v-model="sendMessage" class="form-control" rows="2" placeholder="メッセージを入力"/>
              </div>
              <div class="d-flex flex-row justify-content-between align-items-center">
                <mdb-btn size="sm" v-if="chatMessages.length" color="primary" @click.native="onclickDownloadChatMessages">
                  <mdb-icon icon="download" class="mr-1"/>
                  ダウンロード
                </mdb-btn>
                <div v-else/>
                <div>
                  <mdb-tooltip material trigger="hover" :options="{placement: 'top'}" :disabled="sendMessage === ''">
                    <small v-if="!device.isMobile" slot="tip">Ctrl + Enter</small>
                    <mdb-btn size="sm" slot="reference" color="success" :disabled="sendMessage === ''" @click.native="onclickSubmitChatMessage">送信</mdb-btn>
                  </mdb-tooltip>
                </div>
              </div>
            </div>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </vue-resizable>
  </div>
</template>

<script>
import { urlAutoLink, dateToString } from '@/lib/helper'
import sanitizeHTML from 'sanitize-html'
import VueResizable from 'vue-resizable'

export default {
  name: 'ChatView',
  components: {
    VueResizable
  },
  props: {
    active: Boolean,
    newArrival: Boolean,
    chatMessages: Array,
    device: Object
  },
  data: function() {
    return {
      sendMessage: ''
    }
  },
  methods: {
    onclickDownloadChatMessages: function() {
      this.$emit('onclickDownloadChatMessages')
    },
    onclickSubmitChatMessage: function() {
      const jsonMessage = JSON.stringify({
        date: dateToString({ type: 2 }),
        text: this.sendMessage
      })
      this.$emit('onclickSubmitChatMessage', jsonMessage)
      this.sendMessage = ''
    },
    onKeyBindSubmitChatMessage: function() {
      if (this.sendMessage && this.active) {
        this.onclickSubmitChatMessage()
      }
    },
    sanitizeText: function(text) {
      return sanitizeHTML(urlAutoLink(text))
    }
  },
  watch: {
    chatMessages: function() {

      // NOTE: 0ミリ秒遅延実行で新着メッセージの描画後に強制最下部スクロール
      setTimeout(() => {
        this.$refs.chatMessagesList.scrollTop = this.$refs.chatMessagesList.scrollHeight
      }, 0)
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/_variables.scss";
@import "@/styles/_mediaquery.scss";

.chat-view-wrapper {
  position: fixed;
  top:0;
  left: 0;

  z-index: 3;
  pointer-events: none;
}

.chat-view {
  position: relative;
  background-color: #FFFFFFA0;
  transition: all 300ms 0s ease;
  pointer-events: all;

  @include mq() {
    transform: translateX(-100%);
    width: 40vw;
    min-width: 20vw;
    max-width: 80vw;
  }

  @include mq(sm) {
    transform: translateX(-100%);
    width: 80vw;
    min-width: 40vw;
    max-width: 80vw;
  }

  &.active {

    @include mq() {
      transform: translateX(0);
    }

    @include mq(sm) {
      transform: translateX(0);
    }

    .btn-toggle-chat-view {
      transform: translateX(calc(-100% - 30px));
    }
  }

  .new-badge-wrapper {
    position: absolute;
    top: 0;
    @include mq() {
      right: 20px;
    }

    @include mq(sm) {
      right: 14px;
    }

    .new-badge {
      position: fixed;
      background: #ff3547 !important;
      border-radius: 50%;
      @include mq() {
        width: 20px;
        height: 20px;
      }

      @include mq(sm) {
        width: 14px;
        height: 14px;
      }
    }
  }

  .btn-toggle-chat-view {
    position: absolute;
    top: 10px;
    left: 100%;
    overflow: visible !important;

    @include mq() {
      width: 61.1px;
      height: 61.1px;
      i {
        font-size: 1.625rem;
        line-height: 61.1px;
      }
    }
  }

  .chat-messages-container {
    height: 100vh;

    .chat-messages-list {
      overflow-y: auto;
      padding: 1rem;

      .chat-message {
        margin-right: auto;
        margin-left: 0;
        &.myself {
          margin-right: 0;
          margin-left: auto;

          .display-name {
            font-size: 0.9em;
            color: $secondary-color;
          }
        }

        .chat-message-card-body {
          overflow: hidden;
        }

        .message-date {
          font-size: 0.8em;
        }

        .chat-text {
          white-space: pre-wrap;
          user-select: text;
        }
      }
    }
  }
}
</style>
